export default (config = {}) => ({
    // Delete row modal state
    isDeleteRowOpen: false,
    rowToDelete: null,
    deleteRowModalId: 'confirmingDeletionRowModal',
    
    // Delete section modal state
    isDeleteSectionOpen: false,
    sectionToDelete: null,
    sectionToDeleteRowCount: 0,
    deleteRows: false,
    deleteSectionModalId: 'confirmingDeletionSectionModal',

    confirmDeleteRow(e, rowId) {
        this.rowToDelete = rowId;
        this.isDeleteRowOpen = true;
        this.$dispatch('open-x-modal-listener', {'id': this.deleteRowModalId, 'action': 'open'});
    },

    deleteRow() {
        if (!this.rowToDelete) return;
        
        const rowId = this.rowToDelete;
        
        // Close modal first
        this.isDeleteRowOpen = false;
        this.$dispatch('open-x-modal-listener', {'id': this.deleteRowModalId, 'action': 'close'});
        
        // Remove from local state immediately for instant UI feedback
        const scorecard_rows = this.fullScorecardData?.rows || [];
        const rowIndex = scorecard_rows.findIndex(r => r.id === rowId);
        
        if (rowIndex !== -1) {
            const deletedRow = scorecard_rows[rowIndex];
            scorecard_rows.splice(rowIndex, 1);
            this.fullScorecardData = {
                ...this.fullScorecardData,
                rows: [...scorecard_rows]
            };
            this.sortKey++;
            this.updateFilteredSections();
            
            // Call backend to delete from DB and cache
            this.$wire.call('deleteRow', rowId)
                .then(() => {
                    this.$dispatch('row-deleted', { rowId });
                })
                .catch((error) => {
                    console.error('Error deleting row:', error);
                    // Rollback: re-add the row if backend fails
                    scorecard_rows.splice(rowIndex, 0, deletedRow);
                    this.fullScorecardData = {
                        ...this.fullScorecardData,
                        rows: [...scorecard_rows]
                    };
                    this.sortKey++;
                    this.updateFilteredSections();
                });
        }
        
        this.rowToDelete = null;
    },

    confirmDeleteSection(e, sectionId) {
        this.sectionToDelete = sectionId;
        this.isDeleteSectionOpen = true;
        
        // Count rows in this section
        const scorecard_rows = this.fullScorecardData?.rows || [];
        const rowsInSection = scorecard_rows.filter(r => String(r.scorecard_section_id) === String(sectionId));
        this.sectionToDeleteRowCount = rowsInSection.length;
        
        this.$dispatch('open-x-modal-listener', {'id': this.deleteSectionModalId, 'action': 'open'});
    },

    deleteSection() {
        if (!this.sectionToDelete) return;
        
        const sectionId = this.sectionToDelete;
        const shouldDeleteRows = this.deleteRows;
        
        // Close modal first
        this.isDeleteSectionOpen = false;
        this.$dispatch('open-x-modal-listener', {'id': this.deleteSectionModalId, 'action': 'close'});
        
        // Remove section from local state immediately for instant UI feedback
        const scorecard_sections = this.fullScorecardData?.sections || [];
        const sectionIndex = scorecard_sections.findIndex(s => String(s.id) === String(sectionId));
        
        if (sectionIndex !== -1) {
            const deletedSection = scorecard_sections[sectionIndex];
            scorecard_sections.splice(sectionIndex, 1);
            
            // Handle rows
            let scorecard_rows = this.fullScorecardData?.rows || [];
            let deletedRows = [];
            
            if (shouldDeleteRows) {
                // Filter out rows that belong to this section
                deletedRows = scorecard_rows.filter(r => String(r.scorecard_section_id) === String(sectionId));
                scorecard_rows = scorecard_rows.filter(r => String(r.scorecard_section_id) !== String(sectionId));
            } else {
                // Move rows to GHOST section (ungrouped)
                scorecard_rows = scorecard_rows.map(r => {
                    if (String(r.scorecard_section_id) === String(sectionId)) {
                        return {...r, scorecard_section_id: null};
                    }
                    return r;
                });
            }
            
            this.fullScorecardData = {
                ...this.fullScorecardData,
                sections: [...scorecard_sections],
                rows: [...scorecard_rows]
            };
            this.sortKey++;
            this.updateFilteredSections();
            
            // Call backend to delete from DB and cache
            this.$wire.call('deleteSection', sectionId, shouldDeleteRows)
                .then(() => {
                    const deletedRowIds = shouldDeleteRows ? deletedRows.map(r => r.id) : null;
                    this.$dispatch('section-deleted', { sectionId, deletedRowIds });
                })
                .catch((error) => {
                    console.error('Error deleting section:', error);
                    // Rollback: re-add the section and restore rows
                    scorecard_sections.splice(sectionIndex, 0, deletedSection);
                    
                    let restoredRows = this.fullScorecardData?.rows || [];
                    if (shouldDeleteRows) {
                        restoredRows = [...restoredRows, ...deletedRows];
                    } else {
                        restoredRows = restoredRows.map(r => {
                            const originalRow = deletedRows.find(dr => dr.id === r.id);
                            if (originalRow) {
                                return originalRow;
                            }
                            return r;
                        });
                    }
                    
                    this.fullScorecardData = {
                        ...this.fullScorecardData,
                        sections: [...scorecard_sections],
                        rows: restoredRows
                    };
                    this.sortKey++;
                    this.updateFilteredSections();
                });
        }
        
        this.sectionToDelete = null;
        this.deleteRows = false;
    },
});
